import { Component, ElementRef, OnInit, OnDestroy, TemplateRef, ViewChild, signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';



import { ClientsService } from 'src/app/services/customers/clients.service';
import { ClientSelectService } from 'src/app/services/selects/client-select.service';
import { PdfsService } from 'src/app/services/pdfs/pdfs.service';
import { DialogsService } from '../../../../services/dialogs.service';

import { User } from 'src/app/models/user.model';
import { ClientModel } from 'src/app/models/customers/client.model';
import { ClientSelModel } from 'src/app/models/selects/client.sel.model';
import { ZoneSelModel } from 'src/app/models/selects/zone.sel.model';
import { BusinessTypeSelModel } from 'src/app/models/selects/businesstype.sel.model';
import { UpdatedModelUtilities } from '../../../../utilities/updated.model.utilities';
import { CitySelModel } from '../../../../models/selects/city.sel.model';

import { ClientRequest, GetClientsRequest } from '../presenter/interfaces/client.request';
import { ClientResult } from '../presenter/interfaces/client.result';
import { IsRequestComplete } from 'src/app/interfaces/isrequest-complete';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ClientPresenter } from '../presenter/client.presenter';
import { IFormInputs } from '../../../../interfaces/forms.interface';
import { ClientModalFields } from '../../../../constants/forms/client-modal.fields';
import { GlobalPresenter } from '../../../../services/global/presenter/global.presenter';
import { GlobalRequest } from '../../../../services/global/presenter/global.request';
import { ClienSelectFields } from '../../../../constants/forms/client-select.fileds';
import { VisitPlanFields } from '../../../../constants/forms/visitplan.fileds';
import { CurrentContractFiedls } from '../../../../constants/forms/current-contract.fields';
import { MatDialog } from '@angular/material/dialog';
import { AgreementStatusEnum, CustomerActiveStatus } from '../../../../constants/customers.enum';
//New version elements
import { DateFilterValue } from 'src/app/shared/widgets/document-viewer/components/date-filter/date-filter.component';
import { catchError, filter, map, Observable, of } from 'rxjs';
import { DashboardSummaryService } from 'src/app/shared/services/dashboard-summary.service';
import { createTankStatusColumn, createTankProgressColumn } from '../../../../shared/components/kite-grid/column-utils/column-utils';



@Component({
    selector: 'app-client',
    templateUrl: './client.component.html',
    styleUrls: ['./client.component.scss'],
    standalone: false
})
export class ClientComponent
  implements ClientResult, IsRequestComplete, OnInit {

  @ViewChild('visitPlanModal', { static: true })
  visitPlanModal: TemplateRef<NgbModal>;
  @ViewChild('infoModal', { static: true }) infoModal: TemplateRef<NgbModal>;
  @ViewChild('deleteModal', { static: true })
  deleteModal: TemplateRef<NgbModal>;
  @ViewChild('inputTxt') inputTxt: ElementRef;
  private requestGlobal: GlobalRequest;
  private request: ClientRequest;
  private requestGetClients: GetClientsRequest;

  cellWidth: number = 400;
  tipoMenu: string;
  mostrar: number = 0;
  mostrarSeller: boolean = false;
  clientPopupForm!: UntypedFormGroup;
  clientSelFormHide: boolean = true;
  clientModalForm = this.fb.group(ClientModalFields);
  clientSelectForm = this.fb.group(ClienSelectFields);
  visitPlanModalForm = this.fb.group(VisitPlanFields);
  currentContractForm = this.fb.group(CurrentContractFiedls);
  deleteReasonControl: UntypedFormControl = new UntypedFormControl();
  inputs: IFormInputs = {
    name_client: {
      formControlNameValue: 'name_client',
      label: 'Client Name',
      type: 'text',
      validateOnTouched: true,
    },
  };
  zonessel_list: ZoneSelModel[] = [];
  clientssel_list: ClientSelModel[] = [];
  businessTypessel_list: BusinessTypeSelModel[] = [];
  citysel_list: CitySelModel[] = [];
  user_list: User[] = [];

  client: ClientModel;
  visitPlan_arr = [];
  visitPlan_row = { dateTime: '', note: '' };
  message = '';
  sale_person: string;
  sale_person_id: string;
  usuario: User;
  ROLE = '';
  isDisabled = true;

  canCreateCustomer = false;

  tabletSearchTerm: string = '';

  failMail: any = false;
  okMail: any = false;

  filter: any = {};
  viewExport: any = false;
  filter_options: Array<any> = [
    {
      field: "",
      value: "",
      label: "All"
    },
    {
      field: "status",
      value: "Client",
      label: "Clients"
    },
    {
      field: "status",
      value: "Prospect",
      label: "Prospects"
    },
    {
      field: "active",
      value: "1",
      label: "Actives"
    },
    {
      field: "active",
      value: "x",
      label: "Inactives"
    }
  ]
  // Default filter: Actives only
  selected_values: any[] = [
    { field: 'active', value: '1', label: 'Actives' }
  ];


  columnDefs: any[] = [];
  gridOptions: any = {};


  readonly clients = signal([]);
  loading = signal(false);
  filterStatusBy = signal<any[]>(['1']); // Default: show only active records
  onlyWithSensors = signal<boolean>(false); // Tank Check toggle
  tankSummary = signal<{ linked: number; critical_count: number; normal_count?: number } | null>(null);

  private dateRange: { start: Date, end: Date } | null = null;
  totalRecords: number = 0;
  pageSize: number = 21;


  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private clientsService: ClientsService,
    private clientSelectService: ClientSelectService,
    private activatedRoute: ActivatedRoute,
    private globalPresenter: GlobalPresenter,
    private clientPresenter: ClientPresenter,
    private pdfServices: PdfsService,
    private dialogsService: DialogsService,
    private dashboardSummary: DashboardSummaryService,
    public dialog: MatDialog
  ) {
    this.requestGlobal = globalPresenter;
    globalPresenter.setComponent(this);
    this.request = clientPresenter;
    this.requestGetClients = clientPresenter;
    clientPresenter.setRequestCompleteComponent(this);
    clientPresenter.setComponent(this);
    this.deleteReasonControl?.setValidators([Validators.required]);
  }

  isRequestComplete(
    status: boolean,
    error?: HttpErrorResponse,
    data?: object | any[]
  ): void {
    if (error) this.toastr.error(error.error.msg ?? 'Error');
    setTimeout(() => {
      this.message = status ? 'No Data' : '';
    }, 500);
  }
  getResponse(response: HttpResponse<any>): void {
    this.toastr.success(response['msg']);
    this.loadCustomers();
  }

  // Barra resumen: datos fijos (5 columnas) y handlers de botones
  summaryItems = [
    { title: 'Clients', value: '2 ESTIMATES', color: '#1F7BF6' },
    { title: 'Prospect', value: '6 UNBILLED ACTIVITY', color: '#0D5EA8' },
    { title: 'Installations Pending', value: '5 OVERDUE', color: '#F59E0B' },
    { title: 'Mountly Collected', value: '7 OPEN INVOICES', color: '#9CA3AF' },
    { title: 'Total Collected', value: '2 PAID LAST 30 DAYS', color: '#22C55E' },
  ];

  onSummaryPrimary() {
    this.openClientOnboardingWizard();
  }

  onSummarySecondary() {
    this.exportExcelFile();
  }

  private routerSub!: Subscription;
  private firstLoad = true;

  ngOnInit(): void {
    this.usuario = this.requestGlobal.getUser();
    this.canCreateCustomer = this.usuario?.hasPermission('customers', 'create') || false;
    this.tipoMenu = this.activatedRoute.snapshot.paramMap.get('tipoMenu');
    this.cellWidth = this.tipoMenu !== 'megamenu2' ? 650 : 480;
    this.initAgGrid();
    this.ROLE = this.usuario.role;
    this.sale_person = this.ROLE == 'SALESPER_ROLE' ? this.usuario.name : 'NA';
    this.sale_person_id =
      this.ROLE == 'SALESPER_ROLE' ? this.usuario.uid : 'NA';
    this.crearFormulario(null);
    this.loadCustomers();
    this.cargarSelects();
    this.setFormValues();


    // Recarga el grid al volver de otra ruta (ej: resume del cliente)
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        if (this.firstLoad) { this.firstLoad = false; return; }
        this.loadCustomers();
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  initAgGrid(): void {
    const isMegamenu2 = this.tipoMenu === 'megamenu2';
    
    this.columnDefs = [
      {
        headerName: '',
        width: isMegamenu2 ? 115 : 150,
        pinned: 'left',
        suppressMovable: true,
        resizable: false,
        cellClass: 'ag-cell-center row-header-cell',
        cellRenderer: (params: any) => {
          const item = params.data;
          if (!item) return '';

          let html = '';

          // 1. Eye Button
          html += `
            <button type="button" class="m-1 grid-row-controls info-btn" title="View Customer Resume" aria-label="view customer resume">
              <i class="fa fa-eye i-info" aria-hidden="true"></i>
            </button>
          `;

          // 3. Handshake Button
          if (this.canCreateCustomer) {
            const isActive = this.isCustomerActive(item.active);
            const isClient = item.status === 'Client';
            const disabledClass = (!isActive || isClient) ? 'disabled-row' : '';
            const pointerEvents = isClient ? 'none' : 'auto';
            const title = isClient ? 'Agreement already finalized' : 'Create Services Agreement';
            html += `
              <button type="button" class="m-1 grid-row-controls handshake-btn ${disabledClass}" style="pointer-events: ${pointerEvents}" title="${title}" aria-label="services agreement">
                <i class="fa fa-handshake-o i-sagreement" aria-hidden="true"></i>
              </button>
            `;
          }

          // 4. Trash / Undo Buttons
          if (this.isAdminOrSuperAdmin) {
            const isActive = this.isCustomerActive(item.active);
            if (isActive) {
              html += `
                <button type="button" class="m-1 grid-row-controls delete-btn" title="Inactivate Customer" aria-label="delete customer">
                  <i class="fa fa-trash i-delete" aria-hidden="true"></i>
                </button>
              `;
            } else {
              html += `
                <button type="button" class="m-1 grid-row-controls reactivate-btn" title="Reactivate Customer" aria-label="reactivate customer">
                  <i class="fa fa-undo" aria-hidden="true"></i>
                </button>
              `;
            }
          }

          return html;
        },
        onCellClicked: (params: any) => {
          const target = params.event.target as HTMLElement;
          const button = target.closest('button');
          if (!button) return;

          if (button.classList.contains('info-btn')) {
            this.info(params.data);
          } else if (button.classList.contains('handshake-btn')) {
            this.signature(params.data);
          } else if (button.classList.contains('delete-btn')) {
            this.openInactiveClientModal(params.data);
          } else if (button.classList.contains('reactivate-btn')) {
            this.openReactivateModal(params.data);
          }
        }
      },
      {
        field: 'ident_GUI',
        headerName: 'Business ID',
        ...(isMegamenu2 ? { width: 95 } : { flex: 1, minWidth: 100 }),
        cellClass: 'ag-cell-center',
        valueFormatter: (params: any) => params.value != null ? params.value : '—'
      },
      {
        field: 'name_client_address',
        headerName: 'Business Name',
        ...(isMegamenu2 ? { flex: 2, minWidth: 180 } : { width: this.cellWidth }),
        cellClass: 'ag-cell-left ag-text-data',
        // Tier 0.5: pin DM Sans 14px via inline `cellStyle` so this column
        // matches the typography of the other migrated grids. The class
        // `.ag-text-data` provides an additional SCSS-level safety net
        // (Default.scss) in case future SCSS changes override the inline style.
        cellStyle: { fontFamily: 'DM Sans, sans-serif', fontSize: '14px' },
        cellRenderer: (params: any) => {
          if (!params.value) return '—';
          const name = params.value.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
          if (params.data?.is_qb_linked) {
            // Tier 0.5: inline `style="font-size: 14px"` replaced with the
            // `.icon-qb-linked` class. The size/colour live in Default.scss so
            // we don't drift from the canonical tokens.
            return `
              <div class="d-flex align-items-center gap-1">
                <span>${name}</span>
                <i class="fa fa-check-circle icon-qb-linked" title="Connected to QuickBooks"></i>
              </div>
            `;
          }
          return name;
        }
      },
      {
        field: 'status',
        headerName: 'Status',
        ...(isMegamenu2 ? { width: 80 } : { flex: 1, minWidth: 90 }),
        cellClass: 'ag-cell-center',
        valueFormatter: (params: any) => params.value != null ? params.value : '—'
      },
      {
        field: 'agreement_status',
        headerName: 'Agreement',
        ...(isMegamenu2 ? { width: 90 } : { flex: 1, minWidth: 100 }),
        cellClass: 'ag-cell-center',
        valueFormatter: (params: any) => params.value != null ? params.value : '—'
      },
      {
        field: 'project.price',
        headerName: 'Cost',
        ...(isMegamenu2 ? { width: 85 } : { flex: 1, minWidth: 100 }),
        cellClass: 'ag-cell-center',
        cellRenderer: (params: any) => {
          const project = params.data?.project;
          if (!project) return '—';
          
          const price = project.price;
          const flat_price = project.flat_price;

          if (this.isProjectByPercentage(project)) {
            return price != null ? `${price}%` : '—';
          }
          if (this.isProjectByGallon(project)) {
            return price != null ? `${this.formatAgGridCurrency(price)}/gal` : '—';
          }
          if (this.isProjectByPounds(project)) {
            return price != null ? `${this.formatAgGridCurrency(price)}/lb` : '—';
          }
          if (this.isProjectFlatPrice(project)) {
            return flat_price != null ? `Flat ${this.formatAgGridCurrency(flat_price, 0)}` : '—';
          }
          
          if (price != null) {
            return this.formatAgGridCurrency(price);
          }
          
          return '—';
        }
      }
    ];

    if (!isMegamenu2) {
      this.columnDefs.push({
        field: 'has_eco',
        headerName: 'Services',
        width: 80,
        cellClass: 'ag-cell-center',
        cellRenderer: (params: any) => {
          if (params.data?.has_eco) {
            return `<span class="badge badge-eco" title="ECO service linked"><i class="mdi mdi-leaf"></i> ECO</span>`;
          } else {
            return `<span class="text-muted">—</span>`;
          }
        }
      });
    }

    if (isMegamenu2) {
      this.columnDefs.push(
        createTankStatusColumn({ width: 100 }),
        createTankProgressColumn({ width: 110 })
      );
    }

    this.columnDefs.push(
      {
        field: 'project.container_size',
        headerName: 'Tank',
        ...(isMegamenu2 ? { width: 75 } : { flex: 1, minWidth: 90 }),
        cellClass: 'ag-cell-center',
        valueFormatter: (params: any) => {
          const containerSize = params.data?.project?.container_size;
          return containerSize != null ? containerSize : 0;
        }
      },
      {
        field: 'project.typeAgreement',
        headerName: 'Contract',
        width: isMegamenu2 ? 75 : 100,
        cellClass: 'ag-cell-center',
        cellRenderer: (params: any) => {
          const project = params.data?.project;
          if (!project) return '<span style="color:#e2e8f0; font-size:13px;">—</span>';
          
          if (project.is_master === true || project.typeAgreement === 'msa') {
            return `
              <span title="Master Service Agreement (Corporate)"
                style="display:inline-flex; align-items:center; gap:4px; padding:2px 6px; border-radius:4px; background:#f1f5f9; border:1px solid #e2e8f0;">
                <span style="width:6px; height:6px; border-radius:50%; background:#2e5ea8; flex-shrink:0;"></span>
                <span style="font-size:10px; font-weight:600; color:#475569; letter-spacing:0.3px; line-height:1;">MSA</span>
              </span>
            `;
          }
          if (project.is_master !== true && project.typeAgreement === 'asa') {
            return `
              <span title="Addendum Service Agreement (Branch)"
                style="display:inline-flex; align-items:center; gap:4px; padding:2px 6px; border-radius:4px; background:#f1f5f9; border:1px solid #e2e8f0;">
                <span style="width:6px; height:6px; border-radius:50%; background:#10b981; flex-shrink:0;"></span>
                <span style="font-size:10px; font-weight:600; color:#475569; letter-spacing:0.3px; line-height:1;">ASA</span>
              </span>
            `;
          }
          if (project.is_master !== true && project.typeAgreement === 'single') {
            return `
              <span title="Single Agreement (Independent)"
                style="display:inline-flex; align-items:center; gap:4px; padding:2px 6px; border-radius:4px; background:#f1f5f9; border:1px solid #e2e8f0;">
                <span style="width:6px; height:6px; border-radius:50%; background:#64748b; flex-shrink:0;"></span>
                <span style="font-size:10px; font-weight:600; color:#475569; letter-spacing:0.3px; line-height:1;">SGL</span>
              </span>
            `;
          }
          
          return '<span style="color:#e2e8f0; font-size:13px;">—</span>';
        }
      },
      {
        field: 'sales_person',
        headerName: 'Sales Rep',
        ...(isMegamenu2 ? { flex: 1.2, minWidth: 105 } : { flex: 1.5, minWidth: 130 }),
        cellClass: 'ag-cell-left',
        valueFormatter: (params: any) => params.value != null ? params.value : '—'
      }
    );

    // Override de página: filas inactivas con clase CSS disabled-row
    this.gridOptions = {
      getRowClass: (params: any) => {
        const item = params.data;
        if (item && item.active !== CustomerActiveStatus.Active) {
          return 'disabled-row';
        }
        return '';
      }
    };
  }

  private formatAgGridCurrency(val: any, fractionDigits: number = 2): string {
    if (val == null || val === '') return '—';
    const cleanVal = (val + '').replace('$', '').replace(/,/g, '');
    const num = parseFloat(cleanVal);
    if (isNaN(num)) return '—';
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
  }



  info(client: any) {
    if (!client) return;
    this.router.navigate(['/uco', 'customer', 'resume', client._id]);
  }



  signature(client: any) {
    if (!client) return;
    const isProspect = client.status === 'Prospect';
    const agreementStatus = (client.agreement_status || '').toString().toLowerCase();
    const hasNoAgreement = agreementStatus === 'na' || !agreementStatus;
    const isDraftAgreement = agreementStatus === 'draft';

    if (client.agreement_status == AgreementStatusEnum.Canceled) {
      return this.toastr.warning(
        'This Business signature request has been Recalled. Your sales person is finalizing it — no action needed from you.',
        'Warning',
        {
          enableHtml: true,
        }
      );
    }

    if (isProspect && (hasNoAgreement || isDraftAgreement)) {
      this.dialogsService
        .openClientOnboardingWizard({
          business_types_list: this.businessTypessel_list,
          initialClient: client,
          startAtStep: hasNoAgreement ? 'servicesAgreement' : 'auto',
          clientId: client._id,
        })
        .then(modalRef => modalRef?.result)
        .then((result: any) => {
          if (result) this.loadCustomers();
        });
      return;
    }

  }

  /* 
    delete(flex: wjcGrid.FlexGrid, e: any) {
      let client = flex.selectedItems[0];
  
      if (
        this.ROLE == 'SUPER_ADMIN_ROLE' ||
        this.ROLE == 'ADMIN_ROLE' ||
        this.ROLE == 'SERVMAN_ROLE' ||
        this.ROLE == 'SALESMAN_ROLE'
      ) {
        return this.open(this.deleteModal, 'xl', client);
      }
      if (client.sales_person_id != this.usuario.uid) {
        return this.toastr.warning('No valid selection');
      }
  
      this.open(this.deleteModal, 'xl', client);
    } */

  openReactivateModal(client: any) {
    const client_id = client._id;
    const client_name = client.name_client;
    const client_address = client.address;
    const client_city = client.city;
    const client_business_type = client.business_type;
    this.dialogsService.openConfirmationModal({
      title: 'Reactivate Customer',
      msg: `Do you want to Reactivate the ${client_business_type}
        <strong>${client_name} </strong> Located at
        <strong>${client_address} of ${client_city}</strong>
        City?`,
      confirmText: 'Yes, reactivate it',
      onConfirm: () => this.reactivateCustomer(client_id),
    });
  }



  async cargarSelects() {
    const [zones, clients, businessTypes, userList] = await Promise.allSettled([
      this.requestGlobal.getZonesSelect(),
      this.requestGlobal.getClientsSelect(),
      this.requestGlobal.getBusinessTypesSelect(),
      this.requestGlobal.getUserList(),
    ]);
    if (zones.status === 'fulfilled') this.zonessel_list = zones.value;
    if (clients.status === 'fulfilled') this.clientssel_list = clients.value;
    if (businessTypes.status === 'fulfilled') this.businessTypessel_list = businessTypes.value;
    if (userList.status === 'fulfilled') this.user_list = userList.value;
  }

  get phoneClientModalNoValido() {
    return (
      this.clientModalForm.get('phone')?.invalid &&
      this.clientModalForm.get('phone')?.touched
    );
  }
  get vpBestDateNoValido() {
    return (
      this.visitPlanModalForm.get('best_date')?.invalid &&
      this.visitPlanModalForm.get('best_date')?.touched
    );
  }
  /* get namePopupNoValido() {
  return this.clientPopupForm.get('name_client').invalid && this.clientPopupForm.get('name_client').touched;
}
get addressPopupNoValido() {
  return this.clientPopupForm.get('address').invalid && this.clientPopupForm.get('address').touched;
} */
  get nameNoValido() {
    return (
      this.clientModalForm.get('name_client')?.invalid &&
      this.clientModalForm.get('name_client')?.touched
    );
  }
  get addressNoValido() {
    return (
      this.clientModalForm.get('address')?.invalid &&
      this.clientModalForm.get('address')?.touched
    );
  }
  get sellerNoValido() {
    return (
      this.clientModalForm.get('seller')?.invalid &&
      this.clientModalForm.get('seller')?.touched
    );
  }
  get emailNovalido() {
    return (
      this.clientModalForm.get('email')?.invalid &&
      this.clientModalForm.get('email')?.touched
    );
  }
  get companyNameNoValido() {
    return (
      this.currentContractForm.get('company_name')?.invalid &&
      this.currentContractForm.get('company_name')?.touched
    );
  }
  get endingDateNoValido() {
    return (
      this.currentContractForm.get('ending_date')?.invalid &&
      this.currentContractForm.get('ending_date')?.touched
    );
  }
  get serviceNoValido() {
    return (
      this.currentContractForm.get('service')?.invalid &&
      this.currentContractForm.get('service')?.touched
    );
  }

  /** Verifica si el usuario logueado tiene rol Admin o SuperAdmin */
  get isAdminOrSuperAdmin(): boolean {
    return this.ROLE === 'ADMIN_ROLE' || this.ROLE === 'IT_ROLE' || this.ROLE === 'SUPER_ADMIN_ROLE';
  }

  crearFormulario(data: ClientModel) {
    this.isDisabled =
      //      this.ROLE === 'ADMIN_ROLE' && !!data && data.status === 'Prospect';
      (['ADMIN_ROLE', 'SUPER_ADMIN_ROLE'].includes(this.ROLE)) && !!data && data.status === 'Prospect';


    this.clientPopupForm = this.fb.group({
      _id: [data ? data._id : ''],
      ident_GUI: [data ? data.ident_GUI : ''],
      name_clientsel_id: [data ? data.name_clientsel_id : ''],
      name_client: [
        data ? data.name_client : '',
        [Validators.required, Validators.minLength(1)],
      ],
      name_client_address: [data ? data.name_client_address : ''],
      address: [
        data ? data.address : '',
        [Validators.required, Validators.minLength(1)],
      ],
      address_2: [data ? data.address_2 : ''],
      area: [data ? data.area : ''],
      city: [data ? data.city : ''],
      state: [data ? data.state : ''],
      zip_code: [data ? data.zip_code : ''],
      business_type: [data ? data.business_type : ''],
      contact_name: [data ? data.contact_name : ''],
      email: [data ? data.email : ''],
      phone: [data ? data.phone : ''],
      sales_person: [
        this.usuario.role !== 'SALESPER_ROLE'
          ? data?.sales_person
          : this.usuario.name,
      ],
      sales_person_id: [
        this.usuario.role !== 'SALESPER_ROLE'
          ? data?.sales_person_id
          : this.usuario.uid,
      ],
      citysel: [data ? data.citysel : null],
      current_contract: [data ? data.current_contract : null],
    });

    if (data) {
      const { service, company_name, ending_date } = data.current_contract
        ? data.current_contract
        : { service: '', company_name: '', ending_date: '' };
      this.currentContractForm.setValue({ service, company_name, ending_date });
    }
  }

  private setFormValues(): void {
    this.clientModalForm.controls.sales_person.setValue(this.usuario.name);
    this.clientModalForm.controls.sales_person_id.setValue(this.usuario.uid);
    this.clientSelectForm.controls.sales_person.setValue(this.usuario.name);
    this.clientSelectForm.controls.sales_person_id.setValue(this.usuario.uid);
  }

  async loadCustomers() {
    this.message = '';
    try {
      await this.fetchClients();
    } catch (err) {
    } finally {
      this.loading.set(false);
      this.dashboardSummary.refresh();
    }
  }

  onToggleSensors(): void {
    this.onlyWithSensors.set(!this.onlyWithSensors());
    this.fetchClients(1);
  }

  async fetchClients(page: number = 1) {
    this.loading.set(true);
    const startDate: any = this.dateRange?.start ?? undefined;
    const endDate: any = this.dateRange?.end ?? undefined;
    const filterStr = this.filterStatusBy().length > 0 ? this.filterStatusBy().join(',') : undefined;
    const hasSensor = this.onlyWithSensors() ? true : undefined;
    return await this.requestGetClients.getClients(page, this.pageSize, this.tabletSearchTerm, startDate, endDate, filterStr, hasSensor)
      .then((res: any) => {
        this.clients.set(res.clients);
        this.totalRecords = res.total;
        if (res.tank_summary) this.tankSummary.set(res.tank_summary);
        this.loading.set(false);
      });
  }

  async newCustomer(modal) {
    this.clientSelFormHide = true;
    if (this.clientModalForm.invalid) {
      return Object.values(this.clientModalForm.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    const _clienteSelect = this.clientssel_list.find(
      (x) => x.name == this.clientModalForm.get('name_client')?.value['name']
    );
    if (_clienteSelect != undefined) {
      if (
        this.currentContractForm.get('service')?.value == 'yes' &&
        !this.currentContractForm.valid
      ) {
        if (this.currentContractForm.invalid) {
          return Object.values(this.currentContractForm.controls).forEach(
            (control) => {
              control.markAsTouched();
            }
          );
        }
      }

      if (
        this.currentContractForm.valid &&
        this.currentContractForm.get('service')?.value == 'yes'
      ) {
        this.clientModalForm
          .get('current_contract')
          ?.setValue(this.currentContractForm.value);
      }

      this.clientModalForm
        .get('name_clientsel_id')
        ?.setValue(_clienteSelect._id);
      const name = this.clientModalForm
        .get('name_client')
        ?.value['name'].trim();
      const address = this.clientModalForm.get('address')?.value.trim();
      this.clientModalForm
        .get('name_client_address')
        ?.setValue(`${name} - ${address}`);

      const yy = new Date().getFullYear().toString().slice(-2);
      const last_created_client = await this.request.getLastCreatedClient();
      const lastId: string = last_created_client.ident_GUI || '';
      const lastYY = lastId.slice(2, 4);          // '26' del 'K-260001'
      const lastSeq = Number(lastId.slice(4)) || 0; // '0001' -> 1
      const nextSeq = lastYY === yy ? lastSeq + 1 : 1; // Reinicia si cambió el año
      const _ident = `K-${yy}${String(nextSeq).padStart(4, '0')}`;

      this.clientModalForm.get('ident_GUI')?.setValue(_ident);
      //      if (this.ROLE === 'ADMIN_ROLE') {
      if (['ADMIN_ROLE', 'SUPER_ADMIN_ROLE'].includes(this.ROLE)) {

        const salesPersonName = this.clientModalForm.get('seller')?.value;
        const salesPersonID = this.user_list.filter(
          (user) => user.name == salesPersonName
        )[0].uid;
        this.clientModalForm.get('sales_person')?.setValue(salesPersonName);
        this.clientModalForm.get('sales_person_id')?.setValue(salesPersonID);
      }

      const _citySelect = this.citysel_list.find(
        (x) => x.name == this.clientModalForm.get('city')?.value
      );

      this.clientModalForm
        .get('citysel')
        ?.setValue(_citySelect !== undefined ? _citySelect : null);


      this.request.newClient({
        ...this.clientModalForm.value,
        name_client: name,
      });
      this.resetClientForm();
      this.currentContractForm.reset();
      modal.close();
    } else {
      this.toastr.error('Costumer Invalid Data');
    }
  }

  editCustomer(popup: any) {
    this.clientPopupForm.get('name_client')?.enable();
    const name = this.clientPopupForm.get('name_client')?.value.trim();
    const address = this.clientPopupForm.get('address')?.value.trim();
    this.clientPopupForm
      .get('name_client_address')
      ?.setValue(`${name} - ${address}`);

    if (
      this.currentContractForm.get('service')?.value == 'yes' &&
      !this.currentContractForm.valid
    ) {
      if (this.currentContractForm.invalid) {
        return Object.values(this.currentContractForm.controls).forEach(
          (control) => {
            control.markAsTouched();
          }
        );
      }
    }
    if (
      this.currentContractForm.valid &&
      this.currentContractForm.get('service')?.value == 'yes'
    ) {
      this.clientPopupForm
        .get('current_contract')
        ?.setValue(this.currentContractForm.value);
    }

    if (this.clientPopupForm.invalid) {
      return Object.values(this.clientPopupForm.controls).forEach((control) => {
        control.markAsTouched();
      });
    }

    const _citySelect = this.citysel_list.find(
      (x) => x.name == this.clientPopupForm.get('city')?.value
    );
    this.clientPopupForm
      .get('citysel')
      ?.setValue(_citySelect !== undefined ? _citySelect : null);

    this.request.editClient(this.clientPopupForm.value);
    this.currentContractForm.reset();
    popup.hide();
  }

  deleteCustomer(modal, _cliente: ClientModel) {
    this.request.deleteClient(_cliente._id);
    modal.close();
  }

  validateCurrentService() {
    if (this.currentContractForm.get('service')?.value == 'no') {
      this.currentContractForm.get('company_name')?.setErrors(null);
      this.currentContractForm.get('company_name')?.clearValidators();
      this.currentContractForm.get('company_name')?.updateValueAndValidity();
      this.currentContractForm.get('ending_date')?.setErrors(null);
      this.currentContractForm.get('ending_date')?.clearValidators();
      this.currentContractForm.get('ending_date')?.updateValueAndValidity();
    } else {
      this.currentContractForm
        .get('company_name')
        ?.setValidators([Validators.required]);
      this.currentContractForm.get('company_name')?.updateValueAndValidity();
      this.currentContractForm
        .get('ending_date')
        ?.setValidators([Validators.required]);
      this.currentContractForm.get('ending_date')?.updateValueAndValidity();
    }
  }

  inactiveCustomer(client_id: string): Observable<any> {
    if (!this.deleteReasonControl.valid) {
      this.deleteReasonControl.markAsTouched();
      return of(null);
    }
    const payload = {
      observations: this.deleteReasonControl.value,
    };
    return this.clientsService.inactiveClient(client_id, payload)
      .pipe(
        map((res: any) => {
          res.ok && this.loadCustomers();
          this.dialogsService.openFeedbackSuccess({ title: 'Inactive Client', msg: res.msg });
          this.deleteReasonControl.reset();
        }),
        catchError((err: any) => {
          this.dialogsService.openFeedbackError({ title: 'Inactive Client', msg: err.error?.msg });
          return of(null);
        })
      );
  }

  reactivateCustomer(client_id: string): Observable<any> {
    return this.clientsService.reactivateClient(client_id).pipe(
      map((res: any) => {
        res.ok && this.loadCustomers();
        this.dialogsService.openFeedbackSuccess({ title: 'Reactivate Client', msg: res.msg });
      }),
      catchError((err: any) => {
        this.dialogsService.openFeedbackError({ title: 'Reactivate Client', msg: err.error?.msg });
        return of(null);
      })
    );
  }

  newClientSel() {
    if (this.clientSelectForm.invalid) {
      return Object.values(this.clientSelectForm.controls).forEach(
        (control) => {
          control.markAsTouched();
        }
      );
    }

    this.resetClientForm();

    this.clientSelectService.create(this.clientSelectForm.value).subscribe(
      (res: any) => {
        this.toastr.success(res.msg);
        const { sales_person, sales_person_id } = res.clientsel;
        this.clientSelectForm.reset({ sales_person, sales_person_id });
        this.cargarSelects();
      },
      (error: any) => {
        this.toastr.error(error?.error?.msg || 'Error creating client');
      }
    );
  }

  deleteClientSel(item: ClientSelModel) {
    if (item.sales_person_id != this.usuario.uid) {
      this.toastr.warning('Invalid Action');
      return;
    }
    this.resetClientForm();
    this.clientSelectService.delete(item._id).subscribe(
      async (resp: any) => {
        this.toastr.success(resp.msg);
        this.clientssel_list = await this.requestGlobal.getClientsSelect();
      },
      (error: any) => {
        this.toastr.error(error?.error?.msg || 'Error deleting client');
      }
    );
  }

  newBestDate() {
    if (this.visitPlanModalForm.invalid) {
      return Object.values(this.visitPlanModalForm.controls).forEach(
        (control) => {
          control.markAsTouched();
        }
      );
    }

    this.visitPlan_row.dateTime =
      this.visitPlanModalForm.get('best_date')?.value;
    this.visitPlan_arr.push({ ...this.visitPlan_row });

    this.visitPlanModalForm.reset();
  }

  newVisitPlan(modal) {
    this.request.editClient(this.client);
    this.clientModalForm.reset({
      name_client: this.clientssel_list,
      sales_person: this.sale_person,
      sales_person_id: this.sale_person_id,
    });
    modal.close();
  }

  exporting = false;

  exportExcelFile() {
    if (this.exporting) return;

    this.exporting = true;
    const startDate: any = this.dateRange?.start ?? undefined;
    const endDate: any = this.dateRange?.end ?? undefined;
    const filterStr = this.filterStatusBy().length > 0 ? this.filterStatusBy().join(',') : undefined;

    this.clientsService.exportClientsExcel(this.tabletSearchTerm, startDate, endDate, filterStr).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const now = new Date();
        const formattedDate = now.toISOString().slice(0, 10);
        
        let filterType = 'TotalCustomers';
        if (this.filterStatusBy().length === 1) {
          if (this.filterStatusBy()[0] === 'Client') filterType = 'Clients';
          if (this.filterStatusBy()[0] === 'Prospect') filterType = 'Prospects';
        }

        link.download = `${filterType}_List_${formattedDate}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.exporting = false;
      },
      error: () => {
        this.exporting = false;
      }
    });
  }

  close(modal): void {
    modal.dismiss('Cross click');
    this.clientModalForm.reset();
    this.setFormValues();
  }

  open(content: TemplateRef<NgbModal>, size: string, data): void {
    this.currentContractForm.reset();
    this.client = data;
    if (data) {
      this.visitPlan_arr = data.visit_plans;
    }
    //    if (this.ROLE === 'ADMIN_ROLE') {
    if (['ADMIN_ROLE', 'SUPER_ADMIN_ROLE'].includes(this.ROLE)) {

      this.mostrarSeller = true;
      this.clientModalForm.get('seller')?.setValidators([Validators.required]);
    } else {
      this.mostrarSeller = false;
      this.clientModalForm.get('seller')?.clearValidators();
    }

    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
    });
  }
  openCreateNewClientModal() {
    this.dialogsService
      .openCreateNewClientModal({
        clients_list: this.clientssel_list,
        business_types_list: this.businessTypessel_list,
      })
      ?.result.then((result: any) => {
        if (result) {
          this.loadCustomers();
        }
      });
  }

  openClientOnboardingWizard() {
    this.dialogsService
      .openClientOnboardingWizard({
        business_types_list: this.businessTypessel_list || [],
      })
      .then(modalRef => modalRef?.result)
      .then((result: any) => {
        if (result) {
          this.loadCustomers();
          this.dashboardSummary.refresh();
        }
      });
  }

  private resetClientForm() {
    this.clientModalForm.reset({
      name_client: '',
      area: '',
      state: '',
      business_type: '',
      sales_person: this.sale_person,
      sales_person_id: this.sale_person_id,
    });
  }



  checkMail() {
    let email = this.clientModalForm.get('email')?.value;
    this.clientsService.checkMail(email).subscribe((response: any) => {
      if (!response.ok) {
        this.failMail = true;
        this.okMail = false;
      } else {
        this.failMail = false;
        this.okMail = true;
      }
    });
  }



  onDateFilter(filter: DateFilterValue) {
    if (filter?.type === 'none') {
      this.dateRange = null;
    } else if (filter && filter.startDate && filter.endDate) {
      this.dateRange = { start: filter.startDate, end: filter.endDate };
    } else {
      this.dateRange = null;
    }
    this.fetchClients();
  }

  onStatusFilter(options: any[]) {
    this.selected_values = options;
    this.filterStatusBy.set(options.map(o => o.value));
    this.fetchClients();
  }

  onTabletSearch(term: string) {
    this.tabletSearchTerm = term;
    this.fetchClients();
  }

  openUpdateBusinessInformationModal(client_data: ClientModel) {
    this.dialogsService
      .openUpdateBusinessInformationModal({ client_data })
      .subscribe((result: any) => {
        if (result) {
          this.loadCustomers();
        }
      });
  }
  openResendAgreementEmailModal(client_id: string) {
    this.dialogsService.openResendAgreementEmailModal(client_id);
  }

  // ── Payment-type helpers for Cost column ──────────────────────────────────
  // Evaluates the project object fields from the enriched /clients endpoint.
  // Multiple field formats exist in legacy data (e.g. "true"/"false", "YES"/"NO").

  isProjectByPercentage(project: any): boolean {
    if (!project) return false;
    return project.per_percentage === 'true'
      || project.per_percentage === 'YES'
      || project.reconciliation_type === 'Per_percentage';
  }

  isProjectByGallon(project: any): boolean {
    if (!project) return false;
    return (project.per_gallon === 'true' || project.per_gallon === 'YES')
      && !this.isProjectByPercentage(project);
  }

  isProjectByPounds(project: any): boolean {
    if (!project) return false;
    return (project.per_pounds === 'true' || project.per_pounds === 'YES')
      && !this.isProjectByPercentage(project)
      && !this.isProjectByGallon(project);
  }

  isProjectFlatPrice(project: any): boolean {
    if (!project) return false;
    return project.reconciliation_type === 'flat_price'
      && !!project.flat_price
      && !this.isProjectByPercentage(project);
  }
  // ──────────────────────────────────────────────────────────────────────────

  isCustomerActive(active: string): boolean {
    return active === CustomerActiveStatus.Active;
  }



  openInactiveClientModal(client: ClientModel) {
    const client_id = client._id;
    this.dialogsService.openConfirmationModal({
      title: 'Inactivate Customer',
      msg: `Do you want to Inactive the ${client.business_type}
        <strong>${client.name_client} </strong> Located at
        <strong>${client.address} of ${client.city}</strong>
        City?`,
      reasonControl: this.deleteReasonControl,
      requireReason: true,
      confirmText: 'Yes, inactivate  it',
      onConfirm: () => this.inactiveCustomer(client_id),
    });
  }

  onPageChange(event: any) {
    this.fetchClients(event);
  }

}
